<template>

    <section class="org-area account-section" v-if="loaded">

        <div class="account-container-small">

            <div class="card account-card">

                <div class="card-body card-body-padding">

                    <h1 class="mb-4 h2">Organization Settings</h1>

                    <div class="alert alert-success" v-if="success">
                        Organization settings saved
                    </div>

                    <form method="POST" v-on:submit.prevent="saveOrgSettings()">

                        <div class="form-group">
                            <label class="form-label-admin" for="name">Organization Name</label>
                            <input id="name" type="text" class="form-control" name="name" v-model="organization.name" required>
                            <span class="invalid-feedback show-invalid" role="alert" v-if="this.errors && this.errors.hasOwnProperty('name')">
                                <strong v-text="this.errors.name[0]"></strong>
                            </span>
                        </div>

                        <template v-if="hasPaidPlan()">
                        
                            <div class="form-group">
                                <label class="form-label-admin" for="invoice_emails">Invoice E-Mail(s)</label>
                                <input id="invoice_emails" type="text" class="form-control" name="invoice_emails" v-model="organization.invoice_emails">
                                <span class="invalid-feedback show-invalid" role="alert" v-if="this.errors && this.errors.hasOwnProperty('invoice_emails')">
                                    <strong v-text="this.errors.invoice_emails[0]"></strong>
                                </span>
                                <small class="form-text color-light-bluegray">You can add a list of comma separated emails that would receive automatically emailed invoices.</small>
                            </div>

                            <div class="mb-4">
                                <button class="toggle-button" v-on:click.prevent="showAdvancedSettings = !showAdvancedSettings">Advanced Security Settings</button>
                            </div>

                            <div class="inset-area mt-n3 mb-4" v-if="showAdvancedSettings">
                                <div class="form-group">
                                    <label class="form-label-admin mb-0">Employee Confirm Email</label>
                                    <small class="form-text color-light-bluegray mt-0 mb-2">Employee must confirm their email address before viewing and editing their saved signature</small>
                                    <div>
                                        <label class="switch m-0">
                                            <input type="checkbox" v-model="organization.employee_must_confirm_email">
                                            <span class="slider round"></span>
                                        </label>
                                    </div>
                                </div>
                                <div class="form-group mb-0 border-top pt-2">
                                    <label class="form-label-admin mb-0">Track Only Employee Emails</label>
                                    <small class="form-text color-light-bluegray mt-0 mb-2">Only track and save employee email addresses, without any other employee data</small>
                                    <div>
                                        <label class="switch m-0">
                                            <input type="checkbox" v-model="organization.old_mode_no_employee_sigs">
                                            <span class="slider round"></span>
                                        </label>
                                    </div>
                                </div>
                            </div>

                        </template>

                        <div class="form-group mb-0">
                            <button type="submit" class="btn btn-primary btn-block">
                                Save Organization
                            </button>
                        </div>
                    </form>

                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        data: function () {
            return {
                organization: null,
                loaded: false,
                errors: null,
                showAdvancedSettings: false,
                success: false,
            }
        },
        mounted() {
            var self = this;
            axios.get('/settings/data')
            .then(function (response) {
                if (response.data.status === 'success') {
                    self.organization = response.data.organization;
                    if (self.organization.employee_must_confirm_email || self.organization.old_mode_no_employee_sigs) {
                        self.showAdvancedSettings = true;
                    }
                    self.loaded = true;
                }
            })
            .catch(function (error) {
                console.log(error);
            });
        },
        methods: {
            hasPaidPlan: function() {
                if (this.organization.plan_name !== 'solo') {
                    return true;
                } else {
                    return false;
                }
            },
            saveOrgSettings: function () {
                var self = this;
                axios.post('/settings', { name: self.organization.name, invoice_emails: self.organization.invoice_emails, employee_must_confirm_email: self.organization.employee_must_confirm_email, old_mode_no_employee_sigs: self.organization.old_mode_no_employee_sigs })
                .then(function (response) {
                    if (response.data.status == 'success') {
                        self.success = true;
                    }
                })
                .catch(function (error) {
                    if (error.response.data.errors) {
                        self.errors = error.response.data.errors;
                    } else {
                        console.log(error);
                    }
                });
            }
        }
    }
</script>
